export default "__VITE_ASSET__02057439__"